// utils/time.js

export const formatTime = (timeString) => {
  if (!timeString) return "Brak danych";
  return new Date(timeString).toLocaleTimeString([], {
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit'
  });
};

export const getDelayClass = (delayInSeconds) => {
  if (delayInSeconds === null || delayInSeconds === undefined) return "";
  return delayInSeconds > 0 ? "delay-late" : "delay-early";
};

export const formatDelay = (delayInSeconds) => {
  if (delayInSeconds === null || delayInSeconds === undefined) return "---";
  const minutes = Math.floor(Math.abs(delayInSeconds) / 60);
  const seconds = Math.abs(delayInSeconds) % 60;
  if (delayInSeconds > 0) return `+${minutes}m ${seconds}s`;
  if (delayInSeconds < 0) return `-${minutes}m ${seconds}s`;
  return "0s";
};

export const calculateTimeRemaining = (estimatedTime) => {
  if (!estimatedTime) return "---";
  const currentTime = new Date();
  const departureTime = new Date(estimatedTime);
  const timeDifference = departureTime - currentTime;
  if (timeDifference > 0) {
    const minutes = Math.floor(timeDifference / 60000);
    const seconds = Math.floor((timeDifference % 60000) / 1000);
    return `${minutes}m ${seconds}s`;
  } else {
    return "Odjazd już nastąpił";
  }
};

/**
 * Formats delay in seconds to a human-readable string.
 * < 60s         → "Xs"         (e.g. "45s")
 * 60s – 3599s   → "Xmin Ys"   (e.g. "3min 20s")
 * ≥ 3600s       → "Xh Ymin Zs" (e.g. "1h 5min 30s")
 * Preserves +/- sign for late / early.
 */
export const formatDelayHuman = (delayInSeconds) => {
  if (delayInSeconds === null || delayInSeconds === undefined) return "---";
  if (delayInSeconds === 0) return "0s";

  const sign = delayInSeconds > 0 ? '+' : '-';
  const abs = Math.abs(delayInSeconds);

  if (abs < 60) {
    return `${sign}${abs}s`;
  }

  if (abs < 3600) {
    const mins = Math.floor(abs / 60);
    const secs = abs % 60;
    return secs > 0 ? `${sign}${mins}min ${secs}s` : `${sign}${mins}min`;
  }

  const hours = Math.floor(abs / 3600);
  const mins = Math.floor((abs % 3600) / 60);
  const secs = abs % 60;
  let result = `${sign}${hours}h`;
  if (mins > 0) result += ` ${mins}min`;
  if (secs > 0) result += ` ${secs}s`;
  return result;
};

/**
 * Calculates exact time remaining and returns a detailed string.
 * Returns format like "1h 23min 45s", "5min 30s", or "< 1min".
 */
export const calculateTimeRemainingDetailed = (estimatedTime) => {
  if (!estimatedTime) return "---";
  const currentTime = new Date();
  const departureTime = new Date(estimatedTime);
  const timeDifference = departureTime - currentTime;

  if (timeDifference <= 0) return "Odjazd już nastąpił";

  const totalSeconds = Math.floor(timeDifference / 1000);
  if (totalSeconds < 60) return "< 1min";

  const hours = Math.floor(totalSeconds / 3600);
  const mins = Math.floor((totalSeconds % 3600) / 60);
  const secs = totalSeconds % 60;

  let result = '';
  if (hours > 0) result += `${hours}h `;
  if (mins > 0) result += `${mins}min `;
  if (secs > 0) result += `${secs}s`;
  return result.trim();
};